import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { ReportAdvisePluginService } from './report-advise-plugin.service';

@Component({
  selector: 'report-advise',
  templateUrl: './report-advise.component.html',
  standalone: false
})
export class ReportAdvisePluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;
  public reports: any[];

  constructor(
    public reportAdviseService: ReportAdvisePluginService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.reports = this.plugin.config.ReportAdviseRemarks;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'reportadviseremarks',
      'edit'
    ];
  }
}

PluginComponent.plugins['reportadviseremarks'] = ReportAdvisePluginComponent;
